<template>
  <div class="container">
    <div class="handle-box">
      <el-cascader :props="props" v-model="area_store" placeholder="选择或搜索门店" @visible-change="visibleChange"
        @change="clearStore" collapse-tags clearable filterable></el-cascader>
      <!-- <el-select v-model="query.roomId" clearable placeholder="房间" style="width: 160px;margin-right: 4px;margin-left: 10rpx;">
        <el-option v-for="itm in room_list" :key="itm.id" :label="itm.room_name"
          :value="Number(itm.id)"></el-option>
      </el-select> -->
      <el-button type="primary" icon="el-icon-search" @click="handleSearch" style="margin-left: 10PX;">搜索</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="addRule">添加</el-button>
    </div>
    <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
      :cell-style="centerStyle">
      <el-table-column prop="ID" label="ID" width="55" align="center"></el-table-column>
      <el-table-column prop="name" label="卡券名称" width="200" show-overflow-tooltip
        header-align="center"></el-table-column>
      <el-table-column prop="month" label="卡券价格(元)" width="120" show-overflow-tooltip header-align="center">
        <template #default="scope">
          <span>{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="duration" label="时长(h)" width="80" align="center"></el-table-column>
      <el-table-column label="所属门店" header-align="center" width="220" show-overflow-tooltip>
        <template #default="scope">
          <span>{{ scope.row.store.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="minQuantity" label="可用包厢" header-align="center" show-overflow-tooltip>
        <template #default="scope">
          <div v-if="scope.row.rooms.length > 0">
            <span v-for="item in scope.row.rooms" :key="item.id" style="margin-right: 10px;">{{ item.room_name }}</span>
          </div>
          <span v-else>暂未分配包厢</span>
        </template>
      </el-table-column>
      <el-table-column prop="operatingHoursDesc" label="时间使用描述" show-overflow-tooltip width="120"></el-table-column>
      <el-table-column prop="desc" label="规则描述" show-overflow-tooltip></el-table-column>
      <el-table-column label="是否显示" width="100" align="center">
        <template #default="scope">
          <el-button type="text" :style="'color:' + [!(scope.row.isMiniAppVisible == 1) ? '' : 'green']">
            {{ scope.row.isMiniAppVisible == 1 ? "显示" : "不显示" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="启用状态" width="100" align="center">
        <template #default="scope">
          <el-button type="text" :style="'color:' + [!(scope.row.enabled == 1) ? 'red' : '']">
            {{ scope.row.enabled == 1 ? "启用" : "禁用" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="sequence" label="排序" width="80" align="center"></el-table-column>
      <el-table-column prop="CreatedAt" label="创建日期" show-overflow-tooltip header-align="center"
        :formatter="dateRfcHMS"></el-table-column>
      <el-table-column label="操作" width="240" align="center">
        <template #default="scope">
          <el-button type="text" icon="el-icon-user" @click="getUserList(scope.row.ID)">领取用户
          </el-button>
          <el-button type="text" icon="el-icon-edit" @click="editCoupon(scope.row)">编辑
          </el-button>
          <el-button type="text" style="color: red;" @click="deleteCoupon(scope.row.ID)" icon="el-icon-delete">删除
          </el-button>
        </template>

      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background layout="total, prev, pager, next" :current-page="query.page" :page-size="query.pageSize"
        :total="pageTotal" @current-change="handlePageChange"></el-pagination>
    </div>
    <!-- 编辑弹出框 -->
    <el-dialog v-model="editVisible" :title="actTitle" @close="editVisible = false" :width="950">
      <el-tabs v-model="activeName">
        <el-tab-pane label="卡券信息" name="first">
          <el-form ref="form" :model="form" :rules="rules" label-width="150px">
            <el-form-item prop="name" label="卡券名称：">
              <el-input v-model="form.name" placeholder="请输入等级名称" class="w200"></el-input>
            </el-form-item>
            <el-form-item prop="duration" label="卡券时长（小时）：">
              <el-input-number v-model="form.duration" :controls="false" placeholder="请输入卡券时长"></el-input-number>
            </el-form-item>
            <el-form-item prop="price" label="卡券价格（元）：">
              <el-input-number v-model="form.price" :controls="false" placeholder="请输入卡券价格"></el-input-number>
            </el-form-item>
            <el-form-item prop="usageAfterReceiveLimit" label="领取后有效时间：">
              <el-select v-model="form.usageAfterReceiveLimit" placeholder="请选择领取后有效时间" size="large"
                style="width: 240px">
                <el-option v-for="item in limitInfo" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item prop="price" label="抖音团购ID：">
              <el-input v-model="form.douYinVoucherId" :controls="false" placeholder="请输入抖音团购ID"></el-input>
            </el-form-item>
            <el-form-item prop="price" label="美团团购ID：">
              <el-input v-model="form.meiTuanVoucherId" :controls="false" placeholder="请输入美团团购ID"></el-input>
            </el-form-item>
            <el-form-item prop="isMiniAppVisible" label="是否在小程序展示：">
              <el-switch v-model="form.isMiniAppVisible"></el-switch>
            </el-form-item>
            <el-form-item prop="sequence" label="排序：">
              <el-input-number v-model="form.sequence" :controls="false" placeholder="请输入排序"></el-input-number>
            </el-form-item>
            <el-form-item prop="enabled" label="是否启用：">
              <el-switch v-model="form.enabled"></el-switch>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="卡券规则" name="second">
          <el-form ref="form" :model="form" :rules="rules" label-width="150px">
            <el-form-item prop="operatingHoursDesc" label="可用包厢：">
              <el-select v-model="area" placeholder="请选择地区" size="large" style="width: 240px;margin-right: 10px;">
                <el-option v-for="item in area_list" :key="item.value" :label="item.label" :value="item.value"
                  @click="getStoreList(item.value)" />
              </el-select>
              <el-select v-model="form.storeId" placeholder="请选择门店" size="large"
                style="width: 240px;margin-right: 10px;">
                <el-option v-for="item in store_list" :key="item.value" :label="item.label" :value="item.value"
                  @click="getRoomList({ store_id: item.value })" />
              </el-select>
              <el-select v-model="rooms" multiple placeholder="请选择可用包厢" style="width: 240px">
                <el-option v-for="item in room_list" :key="item.id" :label="item.room_name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item prop="operatingHoursDesc" label="时间使用描述：">
              <el-input type="textarea" resize="none" v-model="form.operatingHoursDesc"
                placeholder="请输入时间使用描述"></el-input>
              <el-tag>时间可用规则描述需要与下方设置的时间保持一致</el-tag>
            </el-form-item>
            <el-form-item prop="operatingHours" label="设置可用时间：">
              <el-button type="primary" @click="addTime" style="margin-bottom: 10px;">添加时间</el-button>
              <div class="time-container">
                <el-card v-for="(item, index) in operatingHours" :key="index" style="margin-bottom: 10px;">
                  <el-tag v-for="(row, row_index) in item.showWeekList" :key="row_index"
                    :type="row.value ? '' : 'danger'" style="margin-right: 10px;">{{ row.label }}</el-tag>

                  <el-button @click="showTimeList(item, index)">编辑</el-button>
                  <el-button type="danger" @click="deleteTime(item)">删除</el-button>
                  <div>
                    <span v-for="(time, index) in item.periodsJson" :key="index" style="margin-right: 30px;">{{
                      time.startTime
                    }} - {{ time.endTime }}</span>
                  </div>
                </el-card>
              </div>
            </el-form-item>
            <el-form-item prop="desc" label="卡券描述：">
              <el-input type="textarea" resize="none" v-model="form.desc" placeholder="卡券描述"></el-input>
            </el-form-item>
            <el-form-item prop="useDesc" label="使用说明：">
              <el-input type="textarea" resize="none" v-model="form.useDesc" placeholder="请输入使用说明"></el-input>
              <el-tag>句子尾部加上“/n”可以换行</el-tag>
            </el-form-item>
            <el-form-item prop="otherDesc" label="其他说明：">
              <el-input type="textarea" resize="none" v-model="form.otherDesc" placeholder="请输入其他说明"></el-input>
              <el-tag>句子尾部加上“/n”可以换行</el-tag>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="卡券内容" name="third">
          <el-form ref="form" :model="form" :rules="rules">
            <el-form-item>
              <tinymce-text id="tinymce" @input="tinymcechange" @release="release" v-model:value="form.memo"
                class="tinymce"></tinymce-text>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div style="text-align: right; margin-top: 10px">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" @click="saveEdit">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑时间段" v-model="timeVisible" @close="timeVisible = false" width="50%">
      <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">
        全周
      </el-checkbox>
      <el-checkbox-group v-model="checkedWeek" @change="handleCheckedCitiesChange">
        <el-checkbox v-for="(week, index) in editWeek" :key="index" :label="week.label" :value="week.value"
          :checked="week.value">
          {{ week.label }}
        </el-checkbox>
      </el-checkbox-group>
      <div class="time-container" style="padding-top: 20px;">
        <div v-for="(item, index) in miniTimeList" :key="index" style="margin-bottom: 20px;">
          <el-time-picker label="可用时间段" v-model="item.time" is-range range-separator="至" start-placeholder="开始时间"
            end-placeholder="结束时间" style="margin-right: 20px;" format="HH:mm" disabled /><el-button type="danger"
            @click="deleteTimeMini(index)">删除该时段</el-button>
        </div>
        <div style="margin-bottom: 20px;">
          <el-time-picker label="可用时间段" v-model="newTime" is-range range-separator="至" start-placeholder="开始时间"
            end-placeholder="结束时间" style="margin-right: 20px;" format="HH:mm" /><el-button
            @click="addTimeMini">添加该时段</el-button>
        </div>
      </div>
      <p> 排序： <el-input-number v-model="timeForm.sequence" :min="0" :max="24" label="排序"
          style="width: 120px;margin-right: 10px;" :controls="false" /></p>

      <el-button type="primary" style="margin-top: 20px;" @click="editTimeMini">全部保存</el-button>
    </el-dialog>
    <!-- 领取用户的列表 -->
    <el-dialog :title="userNum" v-model="userVisible" width="60%">
      <el-table :data="userList" border class="table" ref="multipleTable" header-cell-class-name="table-header"
        :cell-style="centerStyle">
        <el-table-column prop="ID" label="ID" width="55" align="center">
          <template #default="scope">
            <span>{{ scope.row.user.id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="卡券名称" width="200" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <span>{{ scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="称呼" width="200" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <span>{{ scope.row.user.real_name || scope.row.user.nickname }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="手机号码" width="200" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <span>{{ scope.row.user.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <span>{{ couponStatusMap.get(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column property="sourceDesc" label="来源描述" show-overflow-tooltip></el-table-column>
        <el-table-column property="destinationDesc" label="使用描述" show-overflow-tooltip></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background layout="total, prev, pager, next" :current-page="user_query.page"
          :page-size="user_query.pageSize" :total="userPageTotal"
          @current-change="handleUserPageChange"></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getVoucherList, getVoucherDetail, updateVoucherList, createVoucherList, createVoucherTime, updateVoucherTime, deleteVoucherTime, getVoucherTime, deleteVoucher, getVoucherUser } from "../api/card_copons";
import { getAreaOption, getStoreOption } from "../api/store";
import { getRoomList } from "../api/room";
import TinymceText from "@/components/TinymceText";
import { weekList } from "@/constant/weekList";
import moment from "moment";
export default {
  name: "CardCoupons",
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10,
        roomId:null
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      },
      tableData: [],
      pageTotal: 0,
      form: {
        id: 0,
        enabled: 1, //卡券状态（1-启用，2-停用）
        isMiniAppVisible: 1,
        name: "", //卡券名称
        duration: 2, //时长（单位：小时）
        price: 0, //售价
        usageAfterReceiveLimit: 7, //领取后多少天内可用
        desc: "", //卡券规则描述
        operatingHours: [],
        operatingHoursDesc: "", //可用时间规则描述
        storeId: null, //门店 ID
        roomsIdsJson: [],
        useDesc:'超出卡券时长可续时，续时费:100元/半小时（请在订单进行的状态下续时）/n至少提前1天预约',
        otherDesc:'本卡券仅限小程序下单购买/n购买卡券后请联系门店店长使用',
        douYinVoucherId: '',
        meiTuanVoucherId: ''
      },
      actTitle: "新增", // 弹框标题
      editVisible: false, // 弹框开启状态
      userList: [],
      user_query: {
        page: 1,
        pageSize: 10,
        voucherId: null
      },
      userPageTotal: 0,
      userNum: '用户列表（总0人）',
      userVisible: false,
      limitInfo: [
        { value: 99999, label: '不限时间' },
        { value: 1, label: '1天' },
        { value: 3, label: '3天' },
        { value: 7, label: '7天' },
        { value: 15, label: '15天' },
        { value: 30, label: '30天' },
        { value: 60, label: '60天' },
        { value: 90, label: '90天' }
      ],
      limitMap: new Map(),
      showWeekList: [],
      timeVisible: false,
      editWeek: [],
      checkedWeek: [],
      isIndeterminate: false,
      checkAll: false,
      miniTimeList: [],
      newTime: [],
      editIndex: -1,
      activeName: 'first',
      area_list: [],
      store_list: [],
      room_list: [],
      area: null,
      store: null,
      rooms: [],
      timeForm: {
        ownerId: null, //外层列表ID
        ownerType: "cx_voucher", //固定值 cx_voucher
        sequence: 0,
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true,
        sunday: true,
        periodsJson: ''
      },
      couponStatusMap: new Map([
        [1, '未使用'],
        [2, '已使用'],
        [3, '已过期']
      ]),
      operatingHours: [],
      areaOptions: [],
      area_store: [],
      props: {
        // checkStrictly: true,
        lazy: true,
        lazyLoad: this.lazyLoad
      },
    };
  },
  components: {
    TinymceText
  },
  computed: {
    weekList() {
      return weekList
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getData();
      this.getLimitMap()
    },

    lazyLoad(node, resolve) {
      const { level } = node;
      if (level === 0) {
        this.getAreaOptions()
        let nodes = []
        if (this.areaOptions !== []) {
          setTimeout(() => {
            nodes = this.areaOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level === 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
      if (level === 1) {
        let nodes = []
        this.getStoreList(node.value)
        if (this.storeOptions !== []) {
          setTimeout(() => {
            nodes = this.store_list.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level === 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
    },
    // 获取地址列表
    getAreaOptions() {
      getAreaOption().then(res => {
        this.areaOptions = res
      })
    },
    getLimitMap() {
      this.limitInfo.forEach(item => {
        this.limitMap.set(item.value, item.label)
      })
    },
    dateRfcHMS: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return new Date(+new Date(date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
    },

    centerStyle() {
      return 'text-align:center'
    },
    getData() {
      // this.tableData = []
      getVoucherList(this.query).then(res => {
        this.tableData = res.data.list
        this.pageTotal = res.data.total
      })
    },

    visibleChange(val) {
      setTimeout(() => {
        if (!val && this.area_store != null && this.area_store.length > 1) {
          this.query.storeId = this.area_store[1]
          this.getRoomList({ store_id: this.query.storeId })
        }
      }, 200)
    },
    // // 获取房间信息
    // getRoomOption(id) {
    //   this.query.room_id = null
    //   getRoomOption(id).then(res => {
    //     this.roomOptions = res
    //   })
    // },
    clearRoom(val) {
      if (val === null) {
        this.room_list = []
        this.query.roomId = null
      }
    },
    clearStore(val){
      if (val === null) {
        this.store_list = []
        this.query.storeId = null
      }
    },
    // 触发搜索按钮
    handleSearch() {
        this.getData()
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },
    // 用户列表分页导航
    handleUserPageChange(val) {
      this.user_query.page = val
      this.getUserList(this.user_query.voucherId)
    },

    // 添加弹框
    addRule() {
      this.form = {}
      this.actTitle = "新增"
      this.form.id = null
      this.getAreaList()
      this.getStoreList(0)
      this.editVisible = true
    },
    getAreaList() {
      getAreaOption().then(res => {
        this.area_list = res
      })
    },
    getStoreList(id) {
      getStoreOption(id).then(res => {
        this.store_list = res
      })
    },
    getRoomList(id) {
      this.query.room_id = null
      getRoomList(id).then(res => {
        this.room_list = res.data
      })
    },
    getOperatingHours(id) {
      let params = {
        page: 1,
        pageSize: 999,
        ownerId: id,
        ownerType: 'cx_voucher'
      }
      getVoucherTime(params).then(res => {
        this.operatingHours = res.data.list
        this.operatingHours.forEach(item => {
          let showWeekList = []
          for (const key in item) {
            this.weekList.forEach((row) => {
              if (row.value == key) {
                showWeekList.push({
                  english: key,
                  label: row.label,
                  value: item[key]
                })
              }
            });
          }
          item.showWeekList = showWeekList
        })
      })
    },

    // 编辑弹框
    editCoupon(row) {
      this.getAreaList()
      this.getStoreList(0)
      getVoucherDetail(row.ID).then(res => {
        this.getRoomList({ store_id: row.storeId })
        this.actTitle = "编辑"
        this.form = res.data
        this.getOperatingHours(row.ID)
        this.form.enabled = this.form.enabled == 1 ? true : false
        this.form.isMiniAppVisible = this.form.isMiniAppVisible == 1 ? true : false
        this.rooms = this.form.roomsIdsJson
        this.editVisible = true
      })
    },
    // 查看所有小时间段
    showTimeList(row, index) {
      this.editWeek = JSON.parse(JSON.stringify(row.showWeekList))
      this.form.id = row.ID
      this.timeForm.id = row.ID
      this.miniTimeList = JSON.parse(JSON.stringify(row.periodsJson))
      this.miniTimeList.forEach(item => {
        let startTime = new Date('2023-01-01 ' + item.startTime)
        let endTime = new Date('2023-01-01 ' + item.endTime)
        item.time = [startTime, endTime]
      })
      this.checkedWeek = this.editWeek.filter(item => item.value)
        .map(item => item.label)
      this.editIndex = index
      this.timeVisible = true
    },
    // 删除外部时间组合
    deleteTime(row) {
      deleteVoucherTime(JSON.stringify({ id: row.ID })).then(res => {
        if (res.code == 0) {
          this.$message.success('删除成功')
          this.getOperatingHours(this.form.ID)
        }
      })
    },
    // 添加外部时间组合
    addTime() {
      this.miniTimeList = []
      this.timeForm.ownerId = null
      let editWeek = []
      weekList.forEach(item => {
        editWeek.push({
          value: true,
          label: item.label,
          english: item.value
        })
      })
      this.editWeek = JSON.parse(JSON.stringify(editWeek))
      this.checkAll = true
      this.handleCheckAllChange(true)
      this.editIndex = null
      this.timeVisible = true
    },

    // 添加内部小时间段
    addTimeMini() {
      let startTime = moment(parseInt(this.newTime[0].getTime())).format("YYYY-MM-DD HH:mm:ss").slice(11, 16)
      let endTime = moment(parseInt(this.newTime[1].getTime())).format("YYYY-MM-DD HH:mm:ss").slice(11, 16)
      this.miniTimeList.unshift({
        startTime: startTime,
        endTime: endTime,
        time: this.newTime
      })
      this.newTime = []
    },
    // 删除内部小时间段
    deleteTimeMini(index) {
      this.miniTimeList.splice(index, 1)
    },
    // 全部保存添加的小时间段
    editTimeMini() {
      let timeForm = {}
      if (this.miniTimeList.length == 0) {
        this.$message.error('请添加时间段')
        return
      }
      // 编辑时间组合
      this.editWeek.forEach(item => {
        let isCheckedLabel = this.checkedWeek.find(row => row === item.label)
        if (isCheckedLabel) {
          timeForm[item.english] = true
        } else {
          timeForm[item.english] = false
        }
      })
      this.miniTimeList.forEach(item => {
        delete item.time
      })
      timeForm.periodsJson = this.miniTimeList
      if (this.editIndex || this.editIndex === 0) {
        timeForm.id = this.operatingHours[this.editIndex].ID
        updateVoucherTime(JSON.stringify(timeForm)).then(res => {
          if (res) {
            this.$message.success('保存成功')
            this.getOperatingHours(this.form.ID)
            this.form.operatingHours.forEach(item => {
              let showWeekList = []
              for (const key in item) {
                this.weekList.forEach((row) => {
                  if (row.value == key) {
                    showWeekList.push({
                      english: key,
                      label: row.label,
                      value: item[key]
                    })
                  }
                });
              }
              item.showWeekList = showWeekList
            })
            this.timeVisible = false
          }
        })
        // 添加时间组合
      } else {
        timeForm.ownerType = 'cx_voucher'
        timeForm.ownerId = this.form.ID
        createVoucherTime(JSON.stringify(timeForm)).then(res => {
          if (res) {
            this.$message.success('添加成功')
            this.getOperatingHours(this.form.ID)
            this.form.operatingHours.forEach(item => {
              let showWeekList = []
              for (const key in item) {
                this.weekList.forEach((row) => {
                  if (row.value == key) {
                    showWeekList.push({
                      english: key,
                      label: row.label,
                      value: item[key]
                    })
                  }
                });
              }
              item.showWeekList = showWeekList
            })
            this.timeVisible = false
          }
        })
      }
    },
    // 删除外部时间组合
    // removeTime(id) {
    //   deleteVoucherTime(){}
    // },
    // 点击全选按钮
    handleCheckAllChange(val) {
      let allChecked = this.editWeek.map(item => item.label)
      this.checkedWeek = val ? allChecked : []
      this.isIndeterminate = false
    },
    // 点击下方的选择按钮
    handleCheckedCitiesChange(val) {
      const checkedCount = val.length
      this.checkAll = checkedCount === this.editWeek.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.editWeek.length
    },

    saveEdit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        let form = {
          id: Number(this.form.ID),
          enabled: this.form.enabled ? 1 : 2,
          isMiniAppVisible: this.form.isMiniAppVisible ? 1 : 2,
          name: this.form.name,
          roomsIdsJson: this.rooms,
          type: this.form.type,
          storeId: Number(this.form.storeId),
          duration: this.form.duration,
          price: this.form.price,
          usageAfterReceiveLimit: this.form.usageAfterReceiveLimit,
          desc: this.form.desc,
          operatingHoursDesc: this.form.operatingHoursDesc,
          useDesc: this.form.useDesc,
          otherDesc: this.form.otherDesc,
          memo: this.form.memo,
          sequence: this.form.sequence,
          meiTuanVoucherId: this.form.meiTuanVoucherId,
          douYinVoucherId: this.form.douYinVoucherId
        }
        if (this.form.ID) {
          updateVoucherList(JSON.stringify(form)).then(res => {
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.editVisible = false
              this.getData()
            }
          })
        } else {
          createVoucherList(JSON.stringify(form)).then(res => {
            if (res.code === 0) {
              this.$message.success('添加成功')
              this.editVisible = false
              this.getData()
            }
          })
        }
      })
    },
    tinymcechange(content) {
      this.form.memo = content
    },

    // 删除卡券
    deleteCoupon(id) {
      this.$confirm("确定要删除吗？", "删除提示", {
        type: "warning"
      }).then(() => {
        deleteVoucher(JSON.stringify({ id })).then(res => {
          if (res) {
            this.$message.success('删除成功')
          }
          this.getData()
        })
      })
    },
    // 获取领取用户
    getUserList(id) {
      this.user_query.voucherId = id
      getVoucherUser(this.user_query).then(res => {
        if (res.code == 0) {
          this.userList = res.data.list
          this.userNum = '领取用户（总' + res.data.total + '人）'
          this.userPageTotal = res.data.total
          this.userVisible = true
        }
      })
    },
  }
};
</script>
<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.mr10 {
  margin-right: 10px;
}

.w200 {
  width: 200px;
}

.w400 {
  width: 400px !important;
}

.el-input,
.el-input-number {
  width: 220px;
  margin-right: 10px;
}

.el-select {
  width: 220px;
}


.box {
  margin: 0 auto;
}

.box .el-input {
  width: 60%;
}

.rowstyle {
  width: 100%;
  margin: 0 auto;
  padding-left: 15%;
}

.el-row {
  margin-bottom: 10px;
}

.el-col {
  border-radius: 4px;

}

.row-bg {
  padding: 5px 0;
  background-color: #f9fafc;
}

.grid-content {
  border-radius: 4px;
  min-height: 24px;
  text-align: center;
  line-height: 24px;
}

.tip {
  font-size: 12px;
  color: red;
}

.w350 {
  width: 350px;
}

.w250 {
  width: 250px;
}

.time-container {
  max-height: 400px;
  overflow-y: scroll;
}
</style>